<template>
    <v-list>
        <v-list-item
            v-for="page in pages"
            :key="page.text"
            link
            router :to='page.route'
        >
            <v-list-item-action>
                <v-icon>{{ page.icon }}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
                <v-list-item-title>
                    {{ page.text }}
                </v-list-item-title>
            </v-list-item-content>
        </v-list-item>
    </v-list>
</template>

<script>
export default {
    name: "DrawerMenu",
    data: () => ({
        pages: [
            {icon: '', text: 'Главная', route: '/'},
            {icon: '', text: 'Платежи', route: '/report'},
            {icon: '', text: 'Поездки', route: '/transport'},
            // {icon: 'mdi-human-male-child', text: 'Справки',route:'/spravka'},
            // {icon: 'mdi-human-male-child', text: 'ЕГРП',route:'/egrp'},
            {icon: '', text: 'ИПУ', route: '/ipu'},
            {icon: '', text: 'Гимназия Томь', route: '/gimnasia'},
            // {icon: '', text: 'УФПС', route: '/ufps'},
            {icon: '', text: 'Жилсервис', route: '/gilservice'},
            // {icon: '', text: 'Субсидии', route: '/subsidii'},
            // {icon: '', text: 'Очереди', route: '/queue'},
            // {icon: '', text: 'Настройки', route: '/props'},
            // {icon: '', text: 'Выход', route: '/logout'},
            // {icon: '', text: 'Вход', route: '/login'},
        ]
    })
}
</script>


